module.exports = __webpack_public_path__ + "static/media/drs1.png.038609a3.jpg";